// Reach out to PEPS with any questions at #help-peps
import { Router } from "next/router";
import { publicConfig } from "@lululemon/ecom-core";
import "@lululemon/mwa-ab-testing/esm/utils/lapel.css";
import { config, utils, events } from "@lululemon/mwa-ab-testing/esm";
import { subscribe } from "@lululemon/mwa-ab-testing/esm/utils/pubsub";
import { resolveEntry as resolveLDEntry } from "@lululemon/mwa-ab-testing/esm/utils/ld-cache";
// Workarounds
import "./federated-components";

utils.shareExports({
  react: () => Promise.resolve(() => require("react")), // eslint-disable-line global-require
  "@sentry/browser": () => Promise.resolve(() => require("@sentry/browser")), // eslint-disable-line global-require
  "@sentry/node": () => Promise.resolve(() => require("@sentry/node")), // eslint-disable-line global-require
  "@sentry/tracing": () => Promise.resolve(() => require("@sentry/tracing")), // eslint-disable-line global-require
  "next/head": () => Promise.resolve(() => require("next/head")), // eslint-disable-line global-require
  "react-dom": () => Promise.resolve(() => require("react-dom")), // eslint-disable-line global-require
  "next/link": () => Promise.resolve(() => require("next/link")), // eslint-disable-line global-require
  "@lululemon/mwa-ab-testing": () => import("@lululemon/mwa-ab-testing/esm"), // eslint-disable-line global-require
});

config({
  mboxes: {
    maxLapelGlobalCount: publicConfig?.adobeGlobalMboxCount || 10,
    fetchDebounceTime: 30,
    personalizationHost: publicConfig?.personalizationHost,
  },
  launchDarkly: {
    defaultProjectID: publicConfig?.launchDarkly?.clientSideId,
    personalizationFlagID:
      publicConfig?.launchDarkly?.personalizationClientSideId,
    digitalOptimizationClientID:
      publicConfig?.launchDarkly?.digitalOptimizationClientSideId,
  },
});

Object.entries(publicConfig?.launchDarkly?.preloadFlags || {}).forEach(
  ([clientId, flags]) => {
    resolveLDEntry(clientId, flags);
  }
);

if (typeof window !== "undefined") {
  let previousURL;

  const conditionalTrigger = (triggerFunc) => (url) => {
    if (url.includes("/p/")) {
      const currentURLWithoutQueryString = url.split("?")[0];
      if (previousURL !== currentURLWithoutQueryString) {
        // Save the PDP url but exclude the query string
        // since that can change due to size or color selection
        previousURL = currentURLWithoutQueryString;
        triggerFunc(url);
        return true;
      }
    } else {
      // We've transitioned to a new type of page, capture the whole url
      // so if we come back to PDP there is a difference in the url
      previousURL = url;
      triggerFunc(url);
      return true;
    }

    return false;
  };

  let hasTriggeredBeforePageView = false;
  subscribe("pageDataFetchBegin", () => {
    events.triggerPageLoadBegin();
  });
  subscribe("pageDataFetchComplete", () => {
    events.triggerPageLoadComplete();
  });
  Router.events.on("routeChangeStart", (url) => {
    hasTriggeredBeforePageView = conditionalTrigger(
      events.triggerBeforePageView
    )(url);
  });
  Router.events.on("routeChangeComplete", (url) => {
    if (hasTriggeredBeforePageView) {
      // If we've triggered a beforePageView event
      // We want to trigger a pageView event
      events.triggerPageView(url);
    }
  });

  Router.events.on("routeChangeError", (_err, url) => {
    if (hasTriggeredBeforePageView) {
      // If we've triggered a beforePageView event
      // We want to trigger a pageView event
      events.triggerPageView(url);
    }
  });
}

export * from "./hocs";
